import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Logo";
import { toast } from "sonner";
import { Lock, Loader2, AlertTriangle } from "lucide-react";

export default function DefinirPalavraPasse() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setError("Link inválido."); return; }
    api.get(`/auth/invite/${encodeURIComponent(token)}`).then((r) => setInfo(r.data))
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("A palavra-passe deve ter pelo menos 8 caracteres"); return; }
    if (pw !== pw2) { toast.error("As palavras-passe não coincidem"); return; }
    setBusy(true);
    try {
      await api.post("/auth/set-password", { token, password: pw });
      toast.success("Palavra-passe definida. Já pode iniciar sessão.");
      navigate(`/login?email=${encodeURIComponent(info.email)}`);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0D1B2A] p-4">
      <div className="card-almar w-full max-w-md p-8" data-testid="set-password-page">
        <div className="mb-6"><Logo size="md" showText /></div>
        {error ? (
          <div data-testid="set-password-error">
            <p className="flex items-center gap-2 text-red-300"><AlertTriangle size={18} /> {error}</p>
            <button onClick={() => navigate("/login")} className="mt-6 text-sm text-[#E0C574] hover:underline">Ir para o início de sessão</button>
          </div>
        ) : !info ? (
          <Loader2 className="animate-spin text-[#C9A84C]" />
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <h1 className="font-display text-2xl text-white">Bem-vindo, {info.name.split(" ")[0]}</h1>
              <p className="text-sm text-slate-400 mt-1">Defina a palavra-passe da sua conta <span className="text-slate-200" data-testid="set-password-email">{info.email}</span>.</p>
            </div>
            <div className="relative"><Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input type="password" className="input-almar pl-9" placeholder="Nova palavra-passe (mínimo 8 caracteres)" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="set-password-input" required /></div>
            <div className="relative"><Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input type="password" className="input-almar pl-9" placeholder="Confirmar palavra-passe" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="set-password-confirm-input" required /></div>
            <button type="submit" disabled={busy} data-testid="set-password-submit" className="w-full bg-[#C9A84C] hover:bg-[#D9B85C] text-[#0D1B2A] font-semibold py-2.5 rounded-lg transition-colors disabled:opacity-60">
              {busy ? "A guardar..." : "Ativar conta"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
